__turbopack_context__.v({
  "footer": "lifetime-access-modal-module-scss-module__kulweq__footer",
  "icon": "lifetime-access-modal-module-scss-module__kulweq__icon",
  "item": "lifetime-access-modal-module-scss-module__kulweq__item",
  "list": "lifetime-access-modal-module-scss-module__kulweq__list",
  "text": "lifetime-access-modal-module-scss-module__kulweq__text",
});
